import { Component } from '@angular/core';
import { DynamicDialogRef } from 'primeng/dynamicdialog';

/**
 * Editor help (#241).
 *
 * The toolbar's help button used to open markdownguide.org, which documents
 * none of what this editor adds — the `:::` markers, the `{{token}}` family,
 * or the fact that a bad token fails the SITE BUILD rather than the page.
 *
 * Deliberately short. The vocabulary is small, and an author reads this once
 * while writing, not as a manual. Every row carries an example, because that
 * is what people copy.
 *
 * Source of truth is picaluna-v3/docs/CMS-TOKENS-AND-MARKERS.md; this is the
 * at-the-keyboard version of it. If the marker vocabulary changes there, it
 * changes in three places: that doc, renderMarkdown.ts, and here.
 */
@Component({
  selector: 'app-markdown-help',
  templateUrl: './markdown-help.component.html',
  styleUrls: ['./markdown-help.component.scss'],
})
export class MarkdownHelpComponent {
  constructor(public ref: DynamicDialogRef) {}

  /** Buttons do these two; the syntax is here for reading existing copy. */
  formatting = [
    { what: 'Bold', how: '**like this**' },
    { what: 'Italic', how: '*like this*' },
    { what: 'Heading', how: '## A heading' },
    { what: 'Link', how: '[the words](/funeral-cost)' },
    { what: 'Bulleted list', how: '- one line per item' },
  ];

  colour = [
    {
      what: 'A few words',
      how: 'We charge ::: colour-orange $395 ::: for that',
      note: 'Select the words and use the palette button.',
    },
    {
      what: 'A whole paragraph',
      how: '::: colour-forest\nEverything here is forest green.\n:::',
      note: 'The marker sits on its own line, above and below.',
    },
  ];

  align = [
    { what: 'Centre a paragraph', how: '::: center\nCentred text.\n:::' },
    { what: 'Right, left, indent', how: '::: right   ::: left   ::: indent' },
  ];

  combining = [
    {
      what: 'Two at once',
      how: '::: center colour-orange ## A centred orange heading :::',
      note: 'Names are space separated on one marker.',
    },
    {
      what: 'One inside another',
      how: '::: colour-forest Mostly green ::: colour-blue but this bit blue ::: :::',
      note: 'Works, though it gets hard to read quickly.',
    },
  ];

  tokens = [
    { what: 'Phone number', how: '{{copy:site-phone-number}}' },
    { what: 'Email address', how: '{{copy:site-email}}' },
    { what: 'A funeral cost', how: '{{cost:newcastle-burial-with-service.id-itm-7f3a}}' },
  ];

  colourNames = [
    'colour-forest',
    'colour-blue',
    'colour-orange',
    'colour-off-white',
    'colour-brand-black',
    'colour-white',
  ];
}
